import {Component, OnDestroy, OnInit} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {Subscription} from 'rxjs';
import {ProspectService} from '../../services/prospect.service';
import {AddressRequest} from '../../models/request/address/address-request';
import {GrannyFlatSummary} from '../../models/request/prospect/granny-flat-link';
import {StringUtils} from '../../common/string-utils';
import {Constant} from '../../common/constant';

@Component({
  selector: 'ngx-granny-flat-picker',
  templateUrl: './granny-flat-picker.component.html',
  styles: [
    'nb-card {width: 680px; max-width: 94vw; max-height: 88vh;}',
    '.candidate {border-bottom: 1px solid #ddd; padding: 12px 0; display: flex; gap: 12px; align-items: center;}',
    '.candidate span {flex: 1;} .error {color: #b22222;} .search-fields {display: flex; gap: 8px; margin-bottom: 12px;}',
  ],
})
export class GrannyFlatPickerComponent implements OnInit, OnDestroy {
  address: AddressRequest;
  officeId: number;
  prospectId: number;
  candidates: GrannyFlatSummary[] = [];
  sourceLabel = '';
  proposedAddress: AddressRequest;
  fromNumber = '';
  toNumber = '';
  busy = false;
  searched = false;
  error = '';
  StringUtils = StringUtils;
  types = Constant.PROPERTY_TYPE;
  private subscription: Subscription;

  constructor(private ref: NbDialogRef<GrannyFlatPickerComponent>, private prospects: ProspectService) {}
  ngOnInit() { this.sourceLabel = StringUtils.getShortAddress(this.address); this.search(false); }
  ngOnDestroy() { this.subscription?.unsubscribe(); }
  cancel() { this.ref.close(); }
  invalidate() { this.searched = false; this.candidates = []; }
  search(manual = true) {
    this.subscription?.unsubscribe();
    this.busy = true;
    this.error = '';
    this.searched = false;
    const address = manual ? {
      streetId: this.address.streetId, numberFrom: this.fromNumber, numberTo: this.toNumber,
    } : this.address;
    this.subscription = this.prospects.searchMainHouses(address, this.officeId, this.prospectId).subscribe(result => {
      this.proposedAddress = result.data.proposedAddress;
      this.sourceLabel = StringUtils.getShortAddress({...this.address,
        streetName: this.proposedAddress.streetName, districtName: this.proposedAddress.districtName,
        postCode: this.proposedAddress.postCode});
      this.candidates = result.data.candidates || [];
      this.fromNumber = this.proposedAddress.numberFrom;
      this.toNumber = this.proposedAddress.numberTo || '';
      this.busy = false;
      this.searched = true;
    }, error => {
      this.error = error.message || 'Could not search main houses. Please retry.';
      this.busy = false;
    });
  }
  get hasExactMatch(): boolean { return this.candidates.some(item => item.exactMatch); }
  choose(candidate: GrannyFlatSummary) {
    if (!this.busy && this.searched) {
      this.ref.close({link: {parentProspectId: candidate.prospectId}, label: StringUtils.getShortAddress(candidate.address)});
    }
  }
  create() {
    if (this.busy || !this.searched || this.hasExactMatch) { return; }
    this.ref.close({link: {createParentAddress: this.proposedAddress}, label: StringUtils.getShortAddress(this.proposedAddress) + ' (new HGF)'});
  }
}
